// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lujVdMXWJbo2wj {
  min-width: 32px;
  height: 32px;
  margin-bottom: var(--ds-space-0, 0);
}
@media only screen and (max-width: 900px) {
  .lujVdMXWJbo2wj .brG_Ft7VdENgR2 {
    margin-right: var(--ds-space-0, 0);
  }
}
@media only screen and (max-width: 900px) {
  .lujVdMXWJbo2wj .Ww24l5Ewcz8pIG {
    display: none;
  }
}
.lujVdMXWJbo2wj.HdiQtEUzJs4RoV .brG_Ft7VdENgR2 {
  margin-right: var(--ds-space-0, 0);
}
.lujVdMXWJbo2wj.HdiQtEUzJs4RoV .Ww24l5Ewcz8pIG {
  display: none;
}
`, ""]);
// Exports
export var subscribedButton = `lujVdMXWJbo2wj`;
export var subscribedButtonIcon = `brG_Ft7VdENgR2`;
export var buttonText = `Ww24l5Ewcz8pIG`;
export var hideText = `HdiQtEUzJs4RoV`;
export default ___CSS_LOADER_EXPORT___;
